import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface FallbackLinkProps {
  version: 'v1' | 'v2' | 'v3';
  handleClick: () => void;
}

export const FallbackLink = ({
  version,
  handleClick,
}: FallbackLinkProps): ReactElement => {
  const { t } = useTranslation();

  const classNameByVersionMap: { [key: string]: string } = {
    v1: 'processing-result__instruction',
    v2: `processing-result__instruction processing-result__instruction__platform`,
    v3: styles.link,
  };

  return (
    <button
      className={classNameByVersionMap[version] || ''}
      type="button"
      onClick={handleClick}
      data-test="wait-for-instruction-button"
    >
      {t('waitingFor.instruction')}
    </button>
  );
};
